import { render, staticRenderFns } from "./BusinessProductSellingStatusSummary.vue?vue&type=template&id=5bf84c16&scoped=true&"
import script from "./BusinessProductSellingStatusSummary.vue?vue&type=script&lang=ts&"
export * from "./BusinessProductSellingStatusSummary.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProductSellingStatusSummary.vue?vue&type=style&index=0&id=5bf84c16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf84c16",
  null
  
)

export default component.exports